import * as Actions from './scoped-form.actions';
import { IScopedFormDropdownData } from '../../../shared/component/filter/filter.class';
import { Action } from '@ngrx/store';

export interface IFilterScopedFormState {
  isLoading: boolean;
  isLoaded: boolean;
  data: IScopedFormDropdownData[];
}

export const initialFilterScopedFormState: IFilterScopedFormState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterScopedFormReducer(
  state = initialFilterScopedFormState,
  baseAction: Action,
): IFilterScopedFormState {
  const action = baseAction as Actions.FilterScopedFormActions;

  switch (action.type) {
    case Actions.GET_SCOPED_FORMS:
      return { ...state, isLoading: true, isLoaded: false };

    case Actions.GET_SCOPED_FORMS_COMPLETED:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    case Actions.RESET_SCOPED_FORM_STORE:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        data: [],
      };
    default:
      return state;
  }
}
